import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Helmet from 'react-helmet';
import { loginUser, fetchUser, loginWithProvider } from '../../actions/firebase_actions';


class UserLogin extends Component {

    constructor(props) {
        super(props);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.loginWithProvider = this.loginWithProvider.bind(this);
        this.state = {
            message: '',
        };
    }

    loginWithProvider(provider) {
        this.props.loginWithProvider(provider).then(data => {
            if (data.payload.errorCode) {
                this.setState({ message: data.payload.errorMessage });
            }
            else {
                browserHistory.push('/checkin');
            }
        });
        // alert("login with provider");
    }

    onFormSubmit(event) {
        event.preventDefault();

        var email = this.refs.email.value;
        var password = this.refs.password.value;
        this.props.loginUser({ email: email, password: password }).then(data => {
            if (data.payload.errorCode) {
                this.setState({ message: data.payload.errorMessage });
            }
            else {
                browserHistory.push('/profile');
            }
        });

    }

    render() {
        let errorMessage = null;

        if (this.state.message != null && this.state.message !== '') {
            errorMessage = (
                <div className="alert alert-warning" role="alert">
                    { this.state.message }
                </div>
            );
        }

        return (
            <div className="container jumbotron-container vertical-center">
                <Helmet title="Walkabout: Login" />
                <div className="card horizontal-center" style={ { maxWidth: '600px' } }>
                    <div className="card-block text-xs-center">
                        <h2 className="card-title">Welcome Back!</h2>

                        <hr className="hr-depth" />

                        <form id="frmLogin" role="form" onSubmit={ this.onFormSubmit } className="container">
                            { errorMessage }

                            <a href="#" className="btn btn-classy" onClick={() => {
                                this.loginWithProvider("facebook")
                            } } data-provider="facebook" style={ { width: '50%', minWidth: '260px' } }>
                                <i className="fa fa-facebook"></i>
                                Log in with Facebook
                            </a>

                            <div>- or -</div> 

                            <Link to="/register" className="btn btn-classy" style={ { width: '50%', minWidth: '260px' } }>Register</Link>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    loginUser,
    fetchUser,
    loginWithProvider
  }, dispatch);
}

function mapStateToProps(state) {
  return { currentUser: state.currentUser };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserLogin);



// WEBPACK FOOTER //
// ./src/app/components/user/login.jsx